import { Fragment, useContext, useEffect, useState } from 'react';
import { useParams, useHistory } from 'react-router-dom';
import { CopyToClipboard } from 'react-copy-to-clipboard';

import Alert from '../layout/Alert';
import ServerError from '../layout/ServerError';
import SearchTrophy from '../trophys/SearchTrophy';
import Spinner from '../layout/Spinner';
import BackToTop from '../layout/BackToTop';
import Utility from '../util/Utility';

import TTGeneralContainer from '../containers/TTGeneralContainer';
import TTSignatureItemsContainer from '../containers/TTSignatureItemsContainer';
import TTAdditionalNotesContainer from '../containers/TTAdditionalNotesContainer';
import TTForumInfoContainer from '../containers/TTForumInfoContainer';
import TTTimelineContainer from '../containers/TTTimelineContainer';
import TTImagesContainer from '../containers/TTImagesContainer';
import MiniHeroSection from '../containers/MiniHeroSection';

import TrophysContext from '../../context/trophys/trophysContext';

import { REQOP_BY_NUM, REQOP_BY_VRM, REQOP_BY_VIN } from '../../context/types';

const Search = () => {
  const trophysContext = useContext(TrophysContext);
  const { loading, trophy } = trophysContext;
  const history = useHistory();
  const { num, vrm, vin } = useParams();
  const [textCopied, setTextCopied] = useState('');

  useEffect(() => {
    // Checks for routing param - allows automatic search via URL endpoints
    if (num !== undefined) {
      trophysContext.searchTrophy(REQOP_BY_NUM, num);
    } else if (vrm !== undefined) {
      trophysContext.searchTrophy(REQOP_BY_VRM, vrm);
    } else if (vin !== undefined) {
      trophysContext.searchTrophy(REQOP_BY_VIN, vin);
    }

    if (num !== undefined || vrm !== undefined || vin !== undefined) {
      history.push('/search');
    }
  }, [num, vrm, vin, history, trophysContext]);

  const onClickCopy = (urlEndpoint) => {
    // Confirm copy to clipboard action
    setTextCopied('URL copied to clipboard!');

    setTimeout(() => {
      // Remove copy to clipboard confirmation
      setTextCopied('');
    }, 2500);
  };

  return (
    <div className="mb-5">
      <MiniHeroSection
        titleText="Search"
        sectionClassExtra="mb-4"
        iconName="fa-search"
      />

      <div className="container">
        {/* <p>
          Search for a specific Trophy using its unique number, registration
          plate or VIN.
        </p> */}

        <SearchTrophy />
        <Alert />
        <ServerError />

        {textCopied.length > 0 && (
          <div className="simple-toast">{textCopied}</div>
        )}

        {loading && <Spinner />}

        {trophy && (
          <Fragment>
            {!trophy.found ? (
              <div className="card bg-body-tertiary border-warning mt-4 shadow">
                <div className="card-body">
                  <h5 className="card-title text-white">{trophy.info}</h5>
                  <p className="card-text">
                    Please try searching using a different search term.
                  </p>
                </div>
              </div>
            ) : (
              <>
                <small className="d-block text-muted text-center">
                  Data presented cannot be guaranteed accurate as to the
                  vehicle's current state.
                </small>

                <div className="card bg-body-tertiary shadow mt-4">
                  <div className="card-header bg-body-secondary d-flex flex-row justify-content-between align-items-center">
                    <div className="py-2">
                      <h2 className="mb-2 text-white">
                        Trophy #{trophy.info.number.padStart(3, '0')}
                      </h2>
                      <div className="text-muted">
                        Last Updated:
                        <span className="text-white">
                          {' '}
                          {new Date(trophy.info.lastUpdated).toLocaleDateString(
                            undefined,
                            {
                              day: '2-digit',
                              month: '2-digit',
                              year: 'numeric',
                            },
                          )}
                        </span>
                      </div>
                      <small className="text-muted">
                        (
                        {Utility.getPluralisedWithValueIfNeeded(
                          'view',
                          trophy.info.viewHits,
                        )}
                        )
                      </small>
                    </div>
                    <div>
                      <CopyToClipboard
                        text={`${process.env.REACT_APP_TTHOST}search/num/${trophy.info.number}`}
                        onCopy={() =>
                          onClickCopy(
                            `${process.env.REACT_APP_TTHOST}search/num/${trophy.info.number}`,
                          )
                        }
                      >
                        <button
                          type="button"
                          className="btn btn-secondary py-2"
                        >
                          <i
                            className="fa-solid fa-clipboard fa-2x fa-fw text-white"
                            title="Copy URL to Clipboard"
                          />
                        </button>
                      </CopyToClipboard>
                    </div>
                  </div>
                  <div className="card-body">
                    <div className="card-text">
                      {/* Has the vehicle been scrapped? */}
                      {trophy.info.isScrapped && (
                        <div className="alert alert-danger mb-3" role="alert">
                          <i className="fa-solid fa-exclamation-triangle me-2" />
                          <strong>This vehicle has been scrapped.</strong>
                        </div>
                      )}

                      <TTGeneralContainer trophyInfo={trophy.info} />
                      <TTSignatureItemsContainer trophyInfo={trophy.info} />
                      <TTAdditionalNotesContainer trophyInfo={trophy.info} />
                      <TTForumInfoContainer trophyInfo={trophy.info} />
                      <TTTimelineContainer trophyInfo={trophy.info} />
                      <TTImagesContainer trophyInfo={trophy.info} />
                    </div>
                  </div>
                </div>
              </>
            )}
          </Fragment>
        )}
        <BackToTop />
      </div>
    </div>
  );
};

export default Search;
